export class GLProgram {
    _gl: any;
    _vertexShader: any | null;
    _fragmentShader: any | null;
    _program: string | null;
    _attributes: { position: any | null; textCoord: any | null; };
    _uniforms: {};

    constructor(gl, vertex_source, fragment_source) {
        var self = this;
        self._gl = gl;
        self._vertexShader = null;
        self._fragmentShader = null;
        self._program = null;
        self._attributes = {
            'position': null,
            'textCoord': null
        }

        self._uniforms = {
        }

        self._vertexShader = self._compile(self._gl.VERTEX_SHADER, '#version 300 es\n' + vertex_source);
        self._fragmentShader = self._compile(self._gl.FRAGMENT_SHADER, '#version 300 es\n' + fragment_source);

        const program = self._gl.createProgram();
        self._gl.attachShader(program, self._vertexShader);
        self._gl.attachShader(program, self._fragmentShader);
        self._gl.linkProgram(program);

        if (!self._gl.getProgramParameter(program, self._gl.LINK_STATUS)) {
            const errorMsg = "Failed to link program: " + self._gl.getProgramInfoLog(program);
            alert(errorMsg);
            throw new Error(errorMsg);
        }

        self.use();
        self._attributes['position'] = self._gl.getAttribLocation(program, 'a_position');
        self._attributes['textCoord'] = self._gl.getAttribLocation(program, 'a_textCoord');
        self.unuse();

        self._program = program;
    }

    _compile(type, source) {
        var self = this;
        const shader = self._gl.createShader(type);
        self._gl.shaderSource(shader, source);
        self._gl.compileShader(shader);
        if (!self._gl.getShaderParameter(shader, self._gl.COMPILE_STATUS)) {
            alert("Failed to compile shader: " + self._gl.getShaderInfoLog(shader));
            self._gl.deleteShader(shader);
            return null;
        }

        return shader;
    }

    destroy() {
        var self = this;
        self._gl.deleteShader(self._vertexShader);
        self._gl.deleteShader(self._fragmentShader);
        self._gl.deleteProgram(self._program);
    }

    use() {
        var self = this;
        self._gl.useProgram(self._program);
    }

    unuse() {
        this._gl.useProgram(null);
    }

    attributeLocation(name) {
        var self = this;
        if (name in self._attributes) {
            return self._attributes[name];
        } else {
            alert("Invalid attribute name: " + name);
        }
    }

    hasUniformLocation(name) {
        var self = this;
        return name in self._uniforms;
    }

    uniformLocation(name) {
        var self = this;
        if (name in self._uniforms) {
            return self._uniforms[name];
        } else {
            alert("Invalid uniform name: " + name);
        }
    }

}
